/**
 * The authored page architecture (CLAUDE.md §6) — deliberately not the
 * generic Hero → About → Skills → Projects → Contact sequence.
 *
 * One source of truth shared by the nav, the fixed section readout, and the
 * skip-link target, so a renamed or reordered section can never drift
 * between them.
 */

export interface SectionEntry {
  /** DOM id and anchor target. */
  readonly id: string;
  /** Display name — shown in nav and the fixed readout. */
  readonly label: string;
  /** Zero-padded catalog number, e.g. "03". */
  readonly number: string;
}

export const sections: readonly SectionEntry[] = [
  { id: 'intro', label: 'Intro', number: '01' },
  { id: 'work', label: 'Selected Work', number: '02' },
  { id: 'building', label: 'Building', number: '03' },
  { id: 'research', label: 'Research', number: '04' },
  { id: 'lab', label: 'Lab', number: '05' },
  { id: 'about', label: 'About', number: '06' },
  { id: 'writing', label: 'Writing', number: '07' },
  { id: 'contact', label: 'Contact', number: '08' },
] as const;

/** Total, used for the "03 / 08" readout. */
export const sectionCount = String(sections.length).padStart(2, '0');
